import config from '../resources/config.json';
import { equalObjects } from './functions';

export const getVolumeDiscount = (licenses, currency, planId, discounts) => {
    if (!discounts) return 0;
    if (!discounts[currency]) return 0;
    if (!discounts[currency][planId]) return 0;
    
    const maxLicenses = Math.max(...Object.keys(discounts[currency][planId]).map(Number));
    const licensesToUse = Math.min(licenses, maxLicenses);
    
    if (!discounts[currency][planId][licensesToUse]) return 0;
    return discounts[currency][planId][licensesToUse];
}

export const getRates = (selectedLicense, inProgressLicense, rates, currency, decimals, credit, minimumAmount, budget, discounts) => {
    let response = {};
    Object.keys(config.plans).forEach(idLicense => {
        const mSelectedLicense = {
            ...selectedLicense,
            id: idLicense
        }
        if (idLicense != 0) {
            const discountApplied = getVolumeDiscount(mSelectedLicense.licenses, currency, idLicense, discounts);
            const perUserAndMonthOriginal = getRatePerUserAndMonth(mSelectedLicense, rates, 0, decimals);
            const totalPeriodicOriginal = getRateTotalPeriodic(mSelectedLicense, perUserAndMonthOriginal);
            const totalPeriodicWithDiscount = totalPeriodicOriginal * ((100 - discountApplied) / 100);
            const roundMultiplier = Math.pow(10, decimals);
            const totalPeriodic = Math.round(totalPeriodicWithDiscount * roundMultiplier) / roundMultiplier;
            const perUserAndMonth = totalPeriodic / (mSelectedLicense.licenses * config.periodicities[mSelectedLicense.periodicity].months);
            let totalPeriodicApplied;
            if ((budget !== false) && (budget.amount !== false) && (budget.license == mSelectedLicense.id) && (budget.periodicity == mSelectedLicense.periodicity) && (budget.licenses == mSelectedLicense.licenses)) {
                totalPeriodicApplied = budget.amount;
            } else {
                totalPeriodicApplied = totalPeriodic;
            }
            const totalNow = getTotalNow(mSelectedLicense, inProgressLicense, totalPeriodicApplied, credit, minimumAmount);
            response[idLicense] = {
                perUserAndMonth: perUserAndMonth,
                perUserAndMonthOriginal: perUserAndMonthOriginal,
                totalNow: applyVAT(totalNow, selectedLicense.vat, decimals),
                totalPeriodic: applyVAT(totalPeriodicApplied, selectedLicense.vat, decimals),
                totalPeriodicWithoutVAT: totalPeriodic,
                totalPeriodicOriginal: applyVAT(totalPeriodicOriginal, selectedLicense.vat, decimals),
                totalPeriodicOriginalWithoutVAT: totalPeriodicOriginal
            }
        }
    });
    return response;
}

const getRatePerUserAndMonth = (selectedLicense, rates, discountApplied, decimals) => {
    const roundMultiplier = Math.pow(10, decimals);
    let perUserAndMonth = rates[selectedLicense.id][selectedLicense.periodicity];
    perUserAndMonth = perUserAndMonth * ((100 - discountApplied) / 100);
    perUserAndMonth = Math.round(perUserAndMonth * roundMultiplier) / roundMultiplier;
    return perUserAndMonth;
}

const getRateTotalPeriodic = (selectedLicense, perUserAndMonth) => {
    const months = config.periodicities[selectedLicense.periodicity].months
    const totalPeriodic = perUserAndMonth * months * selectedLicense.licenses;
    return totalPeriodic;
}

const applyVAT = (amount, vat, decimals) => {
    const roundMultiplier = Math.pow(10, decimals);
    amount = amount * ((100 + vat) / 100);
    amount = Math.round(amount * roundMultiplier) / roundMultiplier;
    return amount;
}

const getTotalNow = (selectedLicense, inProgressLicense, totalPeriodic, credit, minimumAmount) => {
    let totalNow = totalPeriodic;
    let activateNow = false;
    if (selectedLicense.id > inProgressLicense.id) {
        activateNow = true;
    } else if (selectedLicense.id == inProgressLicense.id) {
        if (selectedLicense.licenses > inProgressLicense.licenses) {
            activateNow = true;
        } else {
            totalNow = 0;
        }
    } else {
        totalNow = 0;
    }
    if (activateNow) {
        totalNow -= credit;
    }
    if (totalNow < minimumAmount) {
        totalNow = 0;
    }
    return totalNow;
}

export const getDiscountForPeriodicities = (rates) => {
    const discounts = {};
    Object.keys(rates).forEach(idLicense => {
        let maxRate = 0;
        discounts[idLicense] = {};
        Object.keys(rates[idLicense]).forEach(periodicity => {
            if (rates[idLicense][periodicity] > maxRate) {
                maxRate = rates[idLicense][periodicity];
            }
        });
        Object.keys(rates[idLicense]).forEach(periodicity => {
            let discount = (maxRate - rates[idLicense][periodicity]) * 100 / maxRate;
            discount = Math.floor(discount / 5) * 5;
            discounts[idLicense][periodicity] = discount;
        });
    });
    return discounts;
}

export const isPayable = (mainReducer, billingFormIsDirty = false) => {
    const currentPaymentMethod = (mainReducer.state.currentPaymentMethod.id === undefined) ? false : mainReducer.state.currentPaymentMethod.id;
    const selectedLicense = { ...mainReducer.state.selectedLicense };
    const currentLicense = { ...mainReducer.state.currentLicense };
    delete selectedLicense.payer_email;
    delete currentLicense.payer_email;
    if (selectedLicense.id == 0) {
        return false;
    }
    if ((equalObjects(selectedLicense, currentLicense)) && ((mainReducer.state.newPaymentMethod === false) || (mainReducer.state.newPaymentMethod.type === false)) && (currentPaymentMethod === mainReducer.state.selectedPaymentMethod) && !billingFormIsDirty) {
        return false;
    } else {
        return true;
    }
}

const isSamePlan = (license, selectedLicense) => (license !== false) &&
    (license.id == selectedLicense.id) &&
    (license.periodicity == selectedLicense.periodicity) &&
    (license.licenses == selectedLicense.licenses);

export const requiresSalesContact = (mainReducer) => {
    const { selectedLicense, budget, currentLicense, inProgressLicense } = mainReducer.state;
    if (selectedLicense.licenses <= config.maxLicenses) {
        return false;
    }
    const matchesBudget = (budget !== false) && isSamePlan({ ...budget, id: budget.license }, selectedLicense);
    return !matchesBudget && !isSamePlan(currentLicense, selectedLicense) && !isSamePlan(inProgressLicense, selectedLicense);
}

export const isInvitedWithoutSubscription = (state) => {
    return (state.inProgressLicense.promotion === true) && (state.currentLicense.id == 0) && (state.selectedLicense.id == 0);
}

export const getPlanMainAction = (state) => {
    if (state.currentLicense.id != 0) {
        return 'change';
    }
    if (state.inProgressLicense.promotion === true) {
        return 'buy';
    }
    if (state.inProgressLicense.id != 0) {
        return 'undoCancel';
    }
    return 'upgrade';
}

export const isLicenseActivatedNow = (mainReducer) => {
    let activateNow = false;
    if (mainReducer.state.selectedLicense.id > mainReducer.state.inProgressLicense.id) {
        activateNow = true;
    } else if (mainReducer.state.selectedLicense.id == mainReducer.state.inProgressLicense.id) {
        if (mainReducer.state.selectedLicense.licenses > mainReducer.state.inProgressLicense.licenses) {
            activateNow = true;
        }
    }
    return activateNow;
}